import Configuration from "./config";
import { decode } from "jsonwebtoken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function generateNonce(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

export function getAuthUrl(originalUrl) {
  var encodedOriginal = encodeURI(originalUrl);
  let state = generateNonce(32);

  //* Store state for CSRF protection
  sessionStorage.setItem("oauth_state", state);
  sessionStorage.setItem("original_url", encodedOriginal);

  //* Authorization Code Flow (no PKCE)
  return (
    Configuration.authorizationEndpoint +
    "?response_type=code" +
    "&client_id=" +
    Configuration.clientId +
    "&scope=" +
    Configuration.scopes +
    "&redirect_uri=" +
    Configuration.redirectUri +
    "&state=" +
    state
  );
}

export const processAuthResults = async (url) => {
  //* Parse URL parameters (code comes as query param, not hash)
  const params = new URLSearchParams(url.split("?")[1]);
  const code = params.get("code");
  const state = params.get("state");
  const error = params.get("error");

  //* Handle errors from auth server
  if (error) {
    throw new Error(`Authentication error: ${error}`);
  }

  //* Validate state for CSRF protection
  const storedState = sessionStorage.getItem("oauth_state");
  if (state !== storedState) {
    throw new Error("Invalid state parameter - possible CSRF attack");
  }

  //* Exchange authorization code for tokens via backend
  const response = await fetch(`${BASE_URL}/generateToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      grant_type: "authorization_code",
      code: code,
      client_id: Configuration.clientId,
      redirect_uri: Configuration.redirectUri,
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to exchange authorization code for tokens");
  }

  const result = await response.json();
  const data = result.token;

  //* Calculate token expiration
  let expiresAt = JSON.stringify(data.expires_in * 1000 + new Date().getTime());

  //* Store tokens
  localStorage.setItem("access_token", data.access_token);
  localStorage.setItem("id_token", data.id_token);
  localStorage.setItem("expires_at", expiresAt);

  //* Clean up session storage
  sessionStorage.removeItem("oauth_state");

  let originalUrl = sessionStorage.getItem("original_url") || "/";
  sessionStorage.removeItem("original_url");

  return decodeURI(originalUrl);
};

export const logout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("id_token");
  localStorage.removeItem("expires_at");
};

export function isAuthenticated() {
  let expireTime = localStorage.getItem("expires_at");
  if (!expireTime) return false;
  let expiresAt = JSON.parse(expireTime);
  return new Date().getTime() < expiresAt;
}

export const getAuthToken = () => {
  if (isAuthenticated() === true) {
    let token = localStorage.getItem("access_token");
    return token;
  } else {
    window.location = getAuthUrl(window.location.pathname);
  }
};

export const getUserEmail = () => {
  let idToken = localStorage.getItem("id_token");
  if (idToken) {
    let decoded = decode(idToken);
    return decoded.sub;
  }
};
